module.exports = __webpack_public_path__ + "static/media/rm_06-27.bdac674e.png";